export default class UserModel {
  id!: number;

  nome!: string;

  isRootUser!: boolean;

  isAtivo!: boolean;
}
